import { render, staticRenderFns } from "./mailEditDialog.vue?vue&type=template&id=650f130e"
import script from "./mailEditDialog.vue?vue&type=script&lang=js"
export * from "./mailEditDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports